import { DayRates } from "../hooks/use_best_day_rates_query";

/**
 * Merges the per-date day rates with the better-hour rates for the selected
 * date, which win where they overlap. Both sides are backend-resolved prices;
 * this only picks a winner, it never derives one.
 */
export function toBestDateRates(
  dateRates: DayRates,
  betterDateRates?: DayRates,
  currencyCode?: string | null
): DayRates | undefined {
  if (!currencyCode) {
    return;
  }
  return { ...dateRates, ...betterDateRates };
}
